module.exports = __webpack_public_path__ + "static/media/3DPPA19.c19cf8b3.jpg";